var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMovetodraft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_movetodraft",
    d: "M17.771,78.428l-6.923-6.261a.691.691,0,0,0-.746-.118.7.7,0,0,0-.41.636v3.5C4.727,76.463.933,79.746.36,84.359L.005,87.206a.694.694,0,0,0,.456.742.672.672,0,0,0,.231.042.693.693,0,0,0,.587-.327l.7-1.121c1.382-2.22,4.147-4.812,7.394-4.812h.323v3.478a.691.691,0,0,0,1.155.518l6.923-6.261a.7.7,0,0,0,0-1.035Z",
    transform: "translate(0 -71.989)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMovetodraft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_movetodraft.001e112ccdcb2320525e5a90bb0ac66e.svg";